import React from 'react';
import classNames from 'classnames';
import { NOT_AVAILABLE_LABEL } from '../../common/constants';
var BasicLabel = function (_a) {
    var value = _a.value, className = _a.className, onClick = _a.onClick, _b = _a.inverted, inverted = _b === void 0 ? false : _b;
    return (React.createElement("span", { onClick: onClick, className: classNames('basicLabel', className, { clickable: !!onClick, inverted: inverted }) }, value ? value : NOT_AVAILABLE_LABEL));
};
export default BasicLabel;
//# sourceMappingURL=BasicLabel.js.map